import { render, staticRenderFns } from "./Inscribed.vue?vue&type=template&id=1ecd1b4d&scoped=true"
import script from "./Inscribed.vue?vue&type=script&lang=js"
export * from "./Inscribed.vue?vue&type=script&lang=js"
import style0 from "./Inscribed.vue?vue&type=style&index=0&id=1ecd1b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd1b4d",
  null
  
)

export default component.exports